import './footer.css'
import logo from '../assets/logo512-white.png';
import facebook from '../assets/facebook.svg';
import linkedin from '../assets/linkedin.svg';
import instagram from '../assets/instagram.svg';
import { Link } from 'react-router-dom';

const SocialIcon = ({icon, link}) => {
    return (
        <div className='social-icon-btn social-button-background' onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}>
            <img alt='icon' src={icon} />
        </div>
    );
}

export default function Footer() {

    return (
        <div id='footer' className='page-padding'>
            <div id='footer-logo-row'>
            </div>
            <div id='footer-columns'>

                {/*Col 1*/}
                <div id='footer-col-1'>
                    <Link to="/"><img id="logo" alt="company-logo" src={logo} /></Link>

                    <div className='footer-column'>
                        <div className='b1 mb-8 mt-3'>
                            Your vision brought to life <br/>
                            through our design and code.<br />
                            Together, we deliver software <br/>
                            that moves things forward.
                        </div>
                    </div>

                    <div className='social-icons mb-8'>
                        <SocialIcon icon={facebook} link='https://www.facebook.com/profile.php?id=61578027117472' />
                        <SocialIcon icon={linkedin} link='https://www.linkedin.com/company/binaryfusion-srl/' />
                        <SocialIcon icon={instagram} link='https://www.instagram.com/binaryfusion.ro' />
                    </div>
                </div>

                {/*Col 2 - Get in touch*/}
                <div id='footer-col-2' className='footer-column column-spacing-2'>
                    <div className='col-title b1-s'>Get In Touch</div>

                    <div>contact@binaryfusion.ro</div>
                    <div>+40741511416</div>
                </div>

                {/*Col 3 - Explore */}
                <div className='footer-column column-spacing-2'>
                    <div className='col-title b1-s'>Explore</div>

                    <Link to="/tehnologies"><div>Tehnologies</div></Link>
                    <Link to="/services"><div>Services</div></Link>
                    <Link to="/case-studies"><div>Projects</div></Link>
                    <Link to="/deep-dives"><div>Deep dives</div></Link>
                    <Link to="/get-in-touch"><div>Get in touch</div></Link>
                </div>

                {/*Col 4 - Find Us On */}
                <div id='footer-col-4' className='footer-column column-spacing-2'>
                    <div className='col-title b1-s'>Find Us On</div>

                    <a className='no-padding-l' href='https://www.linkedin.com/company/binaryfusion-srl/' target='_blank' rel='noreferrer'>LinkedIn</a>
                    <a className='no-padding-l' href='https://www.upwork.com/agencies/1941910185844841738' target='_blank' rel='noreferrer'>Upwork</a>
                    <a className='no-padding-l' href='https://github.com/lupascugabrielcristian' target='_blank' rel='noreferrer'>GitHub</a>
                    <a className='no-padding-l' href='https://www.fiverr.com/gabriellupascu?source=gig_page' target='_blank' rel='noreferrer'>Fiverr</a>
                </div>
            </div>

            <div id='separator-line' />

            <div id='footer-bottom-row' className='mb-1'>
                <div>@2026 Binary Fusion Srl</div>
            </div>
        </div>
    );
}